import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({providedIn: "root" })
export class UserAccountService {
  public readonly showUserMobileSwitcher$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  public setShowUserMobileSwitcher(isShow: boolean): void {
    this.showUserMobileSwitcher$.next(isShow);
  };
}
